module.exports = __webpack_public_path__ + "img/POLARIS.e629a88.jpg";